/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  SearchTasksRequest,
  SetTaskDependenciesRequest,
  TaskDependenciesResponse,
  TaskSearchResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Gets task dependencies by external ID
 */
export const taskDependenciesDependenciesByTaskExternalIdGetV2 = (
  taskExternalId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskDependenciesResponse>(
    {
      url: `/apix/v2/TaskDependencies/${taskExternalId}/dependencies`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getTaskDependenciesDependenciesByTaskExternalIdGetV2QueryKey = (
  taskExternalId?: string,
) => {
  return [`/apix/v2/TaskDependencies/${taskExternalId}/dependencies`] as const;
};

export const getTaskDependenciesDependenciesByTaskExternalIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdGetV2>
    >,
    TError = ErrorType<unknown>,
  >(
    taskExternalId: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdGetV2>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTaskDependenciesDependenciesByTaskExternalIdGetV2QueryKey(
        taskExternalId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdGetV2>
      >
    > = ({ signal }) =>
      taskDependenciesDependenciesByTaskExternalIdGetV2(
        taskExternalId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!taskExternalId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TaskDependenciesDependenciesByTaskExternalIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdGetV2>
    >
  >;
export type TaskDependenciesDependenciesByTaskExternalIdGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Gets task dependencies by external ID
 */

export function useTaskDependenciesDependenciesByTaskExternalIdGetV2<
  TData = Awaited<
    ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  taskExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getTaskDependenciesDependenciesByTaskExternalIdGetV2QueryOptions(
      taskExternalId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Sets task dependencies by external ID (replaces all existing)
 */
export const taskDependenciesDependenciesByTaskExternalIdPatchV2 = (
  taskExternalId: string,
  setTaskDependenciesRequest: BodyType<SetTaskDependenciesRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/TaskDependencies/${taskExternalId}/dependencies`,
      method: "PATCH",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: setTaskDependenciesRequest,
    },
    options,
  );
};

export const getTaskDependenciesDependenciesByTaskExternalIdPatchV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdPatchV2>
      >,
      TError,
      { taskExternalId: string; data: BodyType<SetTaskDependenciesRequest> },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdPatchV2>
    >,
    TError,
    { taskExternalId: string; data: BodyType<SetTaskDependenciesRequest> },
    TContext
  > => {
    const mutationKey = ["taskDependenciesDependenciesByTaskExternalIdPatchV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdPatchV2>
      >,
      { taskExternalId: string; data: BodyType<SetTaskDependenciesRequest> }
    > = (props) => {
      const { taskExternalId, data } = props ?? {};

      return taskDependenciesDependenciesByTaskExternalIdPatchV2(
        taskExternalId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TaskDependenciesDependenciesByTaskExternalIdPatchV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdPatchV2>
    >
  >;
export type TaskDependenciesDependenciesByTaskExternalIdPatchV2MutationBody =
  BodyType<SetTaskDependenciesRequest>;
export type TaskDependenciesDependenciesByTaskExternalIdPatchV2MutationError =
  ErrorType<unknown>;

/**
 * @summary Sets task dependencies by external ID (replaces all existing)
 */
export const useTaskDependenciesDependenciesByTaskExternalIdPatchV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdPatchV2>
    >,
    TError,
    { taskExternalId: string; data: BodyType<SetTaskDependenciesRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof taskDependenciesDependenciesByTaskExternalIdPatchV2>
  >,
  TError,
  { taskExternalId: string; data: BodyType<SetTaskDependenciesRequest> },
  TContext
> => {
  const mutationOptions =
    getTaskDependenciesDependenciesByTaskExternalIdPatchV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Searches for tasks by name across jobs
 */
export const taskDependenciesSearchPostV2 = (
  searchTasksRequest: BodyType<SearchTasksRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<TaskSearchResponse>(
    {
      url: `/apix/v2/TaskDependencies/search`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: searchTasksRequest,
      signal,
    },
    options,
  );
};

export const getTaskDependenciesSearchPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof taskDependenciesSearchPostV2>>,
    TError,
    { data: BodyType<SearchTasksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof taskDependenciesSearchPostV2>>,
  TError,
  { data: BodyType<SearchTasksRequest> },
  TContext
> => {
  const mutationKey = ["taskDependenciesSearchPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof taskDependenciesSearchPostV2>>,
    { data: BodyType<SearchTasksRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return taskDependenciesSearchPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TaskDependenciesSearchPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof taskDependenciesSearchPostV2>>
>;
export type TaskDependenciesSearchPostV2MutationBody =
  BodyType<SearchTasksRequest>;
export type TaskDependenciesSearchPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Searches for tasks by name across jobs
 */
export const useTaskDependenciesSearchPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof taskDependenciesSearchPostV2>>,
    TError,
    { data: BodyType<SearchTasksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof taskDependenciesSearchPostV2>>,
  TError,
  { data: BodyType<SearchTasksRequest> },
  TContext
> => {
  const mutationOptions =
    getTaskDependenciesSearchPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
